import React, { useState } from 'react'
import ResetForm from './designs/ResetForm';
import PasswordSuccess from './designs/PasswordSuccess';
import LoginBanner from 'components/shared/LoginBanner';

const ResetPassword = () => {
  const [tab, setTab] = useState(0)

  const rendered = (val) => {
    switch (val) {
      case 0:
        return <ResetForm setTab={() => setTab(1)} />;
      case 1:
        return <PasswordSuccess setTab={() => setTab(2)} />;
      default:
        return <ResetForm />;
    }
  }

  return (
    <div className="bg-[#F2F2F2] grid grid-cols-1 md:grid-cols-2">
      {rendered(tab)}
      <LoginBanner />
    </div>
  )
}

export default ResetPassword